export type CertificateCategory =
  | "kubernetes"
  | "cloud"
  | "iac"
  | "devops"
  | "security"
  | "other";

export interface CertDomain {
  name: string;
  weight: number;
}

export type Certificate = {
  id: string;
  title: string;
  shortTitle: string;
  issuer: string;
  date: string;
  category: CertificateCategory;
  notes: string;
  credlyLink: string;
  vaultNotesLink: string;
  validUntil: string;
  domains: CertDomain[];
};

export const certificates: Certificate[] = [
  {
    id: "LF-ckad-completed",
    title: "Certified Kubernetes Application Developer (CKAD)",
    shortTitle: "CKAD",
    issuer: "Cloud Native Computing Foundation (CNCF)",
    date: "2025",
    category: "kubernetes",
    notes: "Performance-based exam. 2 hours, 15-20 tasks focused on application lifecycle inside Kubernetes. No multiple choice.",
    credlyLink: "https://www.credly.com",
    vaultNotesLink: "https://brain.rakeshkadam.me/",
    validUntil: "2027",
    domains: [
      { name: "Application Environment, Configuration & Security", weight: 25 },
      { name: "Application Design & Build", weight: 20 },
      { name: "Application Deployment", weight: 20 },
      { name: "Services & Networking", weight: 20 },
      { name: "Application Observability & Maintenance", weight: 15 },
    ],
  },
  {
    id: "MS-az104-completed",
    title: "Microsoft Certified: Azure Administrator Associate (AZ-104)",
    shortTitle: "AZ-104",
    issuer: "Microsoft",
    date: "2021",
    category: "cloud",
    notes: "Demonstrates skills in implementing, managing, and monitoring Azure environments including compute, storage, network, and security resources.",
    credlyLink: "",
    vaultNotesLink: "",
    validUntil: "2023",
    domains: [],
  },
  {
    id: "MS-MCT-2022",
    title: "Microsoft Certified Trainer",
    shortTitle: "MCT",
    issuer: "Microsoft",
    date: "2022",
    category: "other",
    notes: "Active Microsoft Certified Trainer from 2022 through 2023. Delivered training on cloud, infrastructure, and security topics.",
    credlyLink: "",
    vaultNotesLink: "",
    validUntil: "2023",
    domains: [],
  },
];
